import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/FocusZone/FocusZoneUsage.mdx";

import Examples from "../../Docs/Components/FocusZone/FocusZoneExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="FocusZone"
            description="Provide keyboard navigation via arrow keys using a focus zone."
            apiSources={["azure-devops-ui/Components/FocusZone/FocusZone.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;